import { withStyles } from '@material-ui/core/styles'
import { Tooltip } from '@material-ui/core'

export const ToolTipAlert = withStyles(theme => ({
  arrow: {
    color: '#076f9f'
  },
  tooltip: {
    backgroundColor: '#076f9f',
    color: '#ffffff',
    boxShadow: theme.shadows[1],
    fontSize: 16,
    borderRadius: '4px'
  }
}))(Tooltip)
